export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11202.594716d8.jpg";